// src/App.jsx
import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ProtectedLayout } from "./components/ProtectedLayout";
import { Catalog } from "./pages/Catalog";
import { Dashboard } from "./pages/Dashboard";
import { Fulfill } from "./pages/Fulfill";
import { Orders } from "./pages/Orders";
import { ReadyOrders } from "./pages/ReadyOrders";
import OptimizedRouteView from "./pages/OptimizedRouteView";
import PlannedRoutes from "./pages/PlannedRoutes";
import ConfirmedRoutes from "./pages/ConfirmedRoutes";
import ConfirmedRouteView from "./pages/ConfirmedRouteView";
import BroadcastedRoutes from "./pages/BroadcastedRoutes";
import BroadcastedRouteView from "./pages/BroadcastedRouteView";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import PartnerIntegrationsAdmin from "./pages/admin/PartnerIntegrationsAdmin";
import MarketplaceMerchantsAdmin from "./pages/admin/MarketplaceMerchantsAdmin";
import ForgotPassword from "./pages/ForgotPassword";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { StoreProfile } from "./pages/StoreProfile";
import { hydrateMerchantSessionFromStorage } from "./store/useMerchantStore";
import { Link } from "react-router-dom";
import { EmptyState } from "./components/orderKit";
import "leaflet/dist/leaflet.css";
import { t } from "./i18n";
export default function App() {
  useEffect(() => {
    hydrateMerchantSessionFromStorage();
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/merchants" replace />} />
        <Route path="merchants" element={<MarketplaceMerchantsAdmin />} />
        <Route path="partners" element={<PartnerIntegrationsAdmin />} />
      </Route>
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/store-profile" element={<StoreProfile />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/fulfill" element={<Fulfill />} />
        <Route path="/ready-orders" element={<ReadyOrders />} />
        <Route path="/optimized-route/:routeId" element={<OptimizedRouteView />} />
        <Route path="/planned-routes" element={<PlannedRoutes />} />
        <Route path="/confirmed-routes" element={<ConfirmedRoutes />} />
        <Route path="/confirmed-route/:routeId" element={<ConfirmedRouteView />} />
        <Route path="/broadcasted-routes" element={<BroadcastedRoutes />} />
        <Route path="/broadcasted-route/:routeId" element={<BroadcastedRouteView />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

function NotFound() {
  return (
    <div className="page-container" style={{ paddingTop: 40 }}>
      <EmptyState
        icon="fa-compass"
        title={t("notfound.title")}
        message={t("notfound.message")}
        action={
          <Link to="/" className="button-link button-link--primary">
            <i className="fa-solid fa-chart-line" aria-hidden="true" /> {t("notfound.go_dashboard")}
          </Link>
        }
      />
    </div>
  );
}
